import { IArticleVariant } from './IArticleVariant';
import { IBaseArticle } from './IBaseArticle';
import { IArticleLabelInfo } from './IArticleLabelInfo';

export interface IArticle extends IBaseArticle {
  isGiftbox: boolean;
  hasVariants: boolean;
  isBagable: boolean;
  isNonPackable: boolean;
  needsGermanLabel: boolean;
  shortDescription: string;
  articleVariants: IArticleVariant[];
  ean: string;
  taxId: number;
  fullName?: string;
  purchaseUnit: number;
  articleLabelInfo: IArticleLabelInfo;
  isDeleted?: boolean;
  supplierId: number;
  ownProductionIngredients: number[];
  weight?: number;
  packUnit?: string;
  unitId?: number;
  recipeDocumentKey?: string;
  frontRecipeKey?: string;
  backRecipeKey?: string;
  mainArticleVariantId: string;
  defaultArticleVariant: IArticleVariant;
  noWeightForProduction: boolean;
}
